<div class="toast-container position-fixed top-0 end-0 px-3 py-2 m-16 mt-3" style="z-index: 1200">
    <app-toasts></app-toasts>
</div>
<router-outlet></router-outlet>
